module.exports = __webpack_public_path__ + "static/media/termsOfUse.c874b84b.md";